import { render, staticRenderFns } from "./IconButton.vue?vue&type=template&id=c0c6e2d6"
import script from "./IconButton.vue?vue&type=script&lang=js"
export * from "./IconButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sbsdevops/devops/jenkins-slave/workspace/bizbize-frontend-dev/xpermeet-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c0c6e2d6')) {
      api.createRecord('c0c6e2d6', component.options)
    } else {
      api.reload('c0c6e2d6', component.options)
    }
    module.hot.accept("./IconButton.vue?vue&type=template&id=c0c6e2d6", function () {
      api.rerender('c0c6e2d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Shared/IconButton.vue"
export default component.exports